import React, { Component } from 'react';
import { withRouter } from '../../withRouter';
import { connect, } from 'react-redux';

import styles from 'components/Roku/QRLogin/QRLogin.module.scss';
import QRCode from 'qrcode.react';
import { requestQRSession, getQRSession } from 'actions/auth';
import DotLoader from 'components/Utlility/DotLoader';
import { getBaseUrl } from 'helpers/url';
import { resolveSessionCategory } from 'helpers/sessionCategory';

import scanMeUnderline from "images/rokuHeros/scan-me-underline.png";

class QRLogin extends Component {

    constructor(props) {
        super(props);

        this.pollQRSessionInterval = null;

        this.state = {
            sessionID: null,
            expires: null,
            expired: false,
            pollCount: 0,
        };
    }

    componentDidMount() {
        this.generateQRSession();
    }

    componentWillUnmount() {
        clearInterval(this.pollQRSessionInterval);
    }

    generateQRSession = () => {
        clearInterval(this.pollQRSessionInterval);
        if (this.props.auth.isLoggedIn) return;
        this.setState({ sessionID: null, expired: false })
        const oldSessionData = JSON.parse(localStorage.getItem("QRSessionData"));
        this.tryRequestQRSession(oldSessionData);
    }

    tryRequestQRSession = (oldSessionData, retryCount = 10) => {

        const originSessionType = resolveSessionCategory(this.props.appType);
        this.props.requestQRSession(oldSessionData?.sessionID, this.props.TTL ?? 180, originSessionType)
            .then((res) => {
                if (res.status === "Error") throw res.message;
                this.updateExpiresIn(new Date(res.expires));
                this.setState({ sessionID: res.sessionID, expired: false });
                this.pollQRSessionInterval = setInterval(this.pollForQRAuth, 1000);
            }).catch(async (err) => {
                this.setState({ errorMessage: err });
                if (retryCount > 0) {
                    await new Promise(resolve => setTimeout(resolve, 1000));
                    this.tryRequestQRSession(oldSessionData, retryCount - 1);
                }
                else {
                    this.setState({ expired: true });
                    this.updateExpiresIn(new Date());
                }
            });
    }

    pollForQRAuth = () => {
        this.setState({ pollCount: this.state.pollCount + 1 });
        this.updateExpiresIn(this.state.expires);
        if (this.state.pollCount % 4 !== 0) return;

        this.props.getQRSession(this.state.sessionID)
            .then((res) => {
                this.updateExpiresIn(new Date(res.expires + 'Z'));
                if (res.user) {
                    clearInterval(this.pollQRSessionInterval);

                    this.props.onLogin(this.state.sessionID);
                } else if (res.error) {
                    this.handlePollError(res.error);
                }
            })
            .catch((err) => {
                this.handlePollError(err);
            });
    }

    handlePollError = (err) => {
        clearInterval(this.pollQRSessionInterval);

        localStorage.removeItem("QRSessionData");
        this.setState({ sessionID: null, errorMessage: "Your session has expired please restart the app.", expired: true });
        this.updateExpiresIn(new Date());
    }

    updateExpiresIn = (expires) => {
        const now = new Date();
        const timeLeft = new Date(expires - now);
        if (timeLeft.getTime() <= 0) {
            this.setState({ expired: true, sessionID: null });
            clearInterval(this.pollQRSessionInterval);
        } else {
            this.setState({ expires, sessionExpiresIn: timeLeft });
        }
    }

    getExpiresInString = () => {
        if (!this.state.sessionExpiresIn) return "-";
        var minuets = this.state.sessionExpiresIn.getMinutes();
        var seconds = this.state.sessionExpiresIn.getSeconds();
        minuets = isNaN(minuets) ? 0 : minuets;
        seconds = isNaN(seconds) ? 0 : seconds;
        if (minuets <= 0 && seconds <= 0) return "Expired";
        return `${minuets}m ${seconds}s`;
    }

    render() {
        const baseUrl = getBaseUrl();
        const url = `${baseUrl}/login?QRSessionID=${this.state.sessionID}&loginAppType=${this.props.appType}`;
        const qrColor = this.props.color || "white";

        return (
            <div className={styles.qrLogin}>
                <div className={styles.qrFrame}>
                    {this.state.sessionID ? (
                        <QRCode
                            size={256}
                            style={{ width: "100%", height: "100%" }}
                            bgColor="transparent"
                            fgColor={qrColor}
                            className={styles.qrCode}
                            value={url}
                        />
                    ) : (
                        <div className={styles.qrPlaceholder}>
                            {this.state.expired
                                ? this.props.expiredMessage
                                    ? <p className={styles.expiredMsg}>{this.props.expiredMessage}</p>
                                    : <button className={styles.retryBtn} onClick={() => this.generateQRSession()}>Retry</button>
                                : <DotLoader size="medium" variant="dark" />
                            }
                        </div>
                    )}
                </div>
                <a href={url} className={styles.scanMeLink}>
                    <span className={styles.scanMeText} style={this.props.textStyle}>SCAN ME</span>
                    <img className={styles.scanMeUnderline} src={scanMeUnderline} alt="" />
                </a>
                <p className={styles.expires} style={this.props.textStyle}>
                    Expires in: {this.getExpiresInString()}
                </p>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        pricing: state.pricing,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        requestQRSession: (oldSessionID, ttl, originSessionType) => {
            return dispatch(requestQRSession(oldSessionID, ttl, originSessionType));
        },
        getQRSession: (QRSessionID) => {
            return dispatch(getQRSession(QRSessionID));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(QRLogin));
